<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="/" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"
        ><img src="/SotaExLogo.svg" alt=""
      /></span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img src="/SotaExLogo.svg" alt="" /> </span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar_admin">
      <!-- Sidebar toggle button-->
      <a
        href="#"
        class="button_navbar"
        data-toggle="push-menu"
        role="button"
        :class="[expand ? 'icon-menu-3' : 'icon-menu-2']"
        @click="changeExpand"
      >
        <span class="sr-only">Toggle navigation</span>
      </a>

      <!-- Navbar Right Menu -->
      <div class="navbar_admin_custom">
        <ul class="navbar_nav">
          <!-- <li class="item dropdown notifications-menu">
            <a href="#" class="dropdown-toggle notify_head" data-toggle="dropdown">
              <i class="icon-bell"></i>
              <span class="number_warning">{{ unreadNotificationsCount }}</span>
            </a>
            <div class="dropdown-menu">
              <ul class="list_warning">
                <li class="header"><span>You have {{ unreadNotificationsCount }} notifications</span></li>
                <li>
                 <span>inner menu: contains the actual data</span>
                 <ul class="menu">
                   <li v-for="notification in notifications"
                       :class="{unread: !notification.read_at}"
                       @click.stop="markAsRead(notification)">
                     <a href="javascript:void(0)" :title="notification.data.data">
                       {{notification.data.data}}
                     </a>
                   </li>
                 </ul>
                </li>
                <li class="footer"><a href="#">View all</a></li>
              </ul>
            </div>
          </li> -->
          <li class="item user_navbar">
            <span class="email_user_navbar">{{ currentAdmin?.email }}</span>
            <i class="icon-menu" @click="showLogout = !showLogout"> </i>
          </li>

          <!-- <li class="item dropdown notifications-menu">
            <a href="#" class="dropdown-toggle lang_show"  data-toggle="dropdown">
              <span class="txt_lang_show">EN</span>
              <!-- <i class="icon_dropdow icon-arrow1"></i> -->
          <!-- </a> -->
          <!-- <div class="dropdown-menu">
              <ul class="list_lang">
                <li>
                  <a @click="changeLanguage('en')" :class="{'active': lang == 'en'}">
                   <img class="img_lang_navbar" src="/images/flags/uk_24_36.png" height="14px"/> English
                  </a>
                </li>
                <li>
                  <a @click="changeLanguage('vi')" :class="{'active': lang == 'vi'}">
                   <img class="img_lang_navbar" src="/images/flags/vietnam_24_36.png" height="14px"/> Tiếng Việt
                  </a>
                </li>
              </ul>
            </div>
          </li> -->

          <!-- <li class="item dropdown notifications-menu"> -->

          <!-- </li> -->
        </ul>
        <div
          id="dropdown-logout"
          class="dropdown-head"
          v-if="showLogout"
          @focus="showLogout = true"
        >
          <ul>
            <li>
              <a href="#" @click="showModalChangePassword()">Change password</a>
            </li>
            <li>
              <a href="#" class="" @click.stop="logout()">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <ChangePassword></ChangePassword>
  </header>
</template>

<script>
import ChangePassword from "@/pages/ChangePassword";
import rf from "../lib/RequestFactory";
import RemoveErrorsMixin from "./RemoveErrorsMixin";

export default {
  components: {
    ChangePassword,
  },
  mixins: [RemoveErrorsMixin],
  data() {
    return {
      csrfToken: window.csrf_token,
      notifications: [],
      lang: this.$route.query.lang || document.documentElement.lang,
      currentAdmin: {},
      expand: true,
      showLogout: false,
    };
  },

  computed: {
    unreadNotificationsCount() {
      return _.chain(this.notifications)
        .filter((item) => {
          return item.read_at === null;
        })
        .size()
        .value();
    },
    hideDropdownLogout() {
      return this.showLogout;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      window.axios.defaults.headers.common["Authorization"] = "";
      window.location.href = "/login";
    },
    changeExpand() {
      this.expand = !this.expand;
      if (!this.expand) {
        document.body.classList.add("sidebar-collapse");
      } else {
        document.body.classList.remove("sidebar-collapse");
      }
    },
    showModalChangePassword() {
      this.showLogout = false;
      window.ChangePassword.show("ChangePassword");
    },
    markAsRead(notification) {
      if (notification.read_at) {
        return;
      }
      rf.getRequest("NotificationRequest")
        .markAsRead(notification.id)
        .then((res) => {
          notification.read_at = res.data.read_at;
        });
    },

    listenForNotification() {
      window.Echo.channel("App.Models.Admin").listen(
        "AdminNotificationUpdated",
        () => {
          this.getNotifications();
        }
      );
    },

    getNotifications() {
      rf.getRequest("NotificationRequest")
        .getNotifications()
        .then((res) => {
          this.notifications = res.data.data;
        });
    },

    changeLanguage(lang) {
      const currentRouter = this.$router.currentRoute;
      const newQuery = Object.assign(currentRouter.query, { lang: lang });

      const params = this.toParams(newQuery);
      window.location.href = `${window.location.origin}${window.location.pathname}?${params}`;
    },

    toParams(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return `${key}=${obj[key]}`;
        })
        .join("&");
    },

    getCurrentAdmin() {
      rf.getRequest("UserRequest")
        .getCurrentAdmin()
        .then((res) => {
          this.currentAdmin = res;
        })
        .catch((error) => {
          if (!error.response) {
            Message.error(
              window.i18n.t("common.message.network_error"),
              {},
              { position: "bottom_left" }
            );
            return;
          }
          this.convertRemoteErrors(error);
        });
    },
  },
  created() {
    let self = this;
    window.addEventListener("click", function (e) {
      if (!self.$el.contains(e.target)) {
        self.showLogout = false;
      }
    });
  },
  mounted() {
    this.getCurrentAdmin();
    window.addEventListener("click", function (e) {});
    // this.getNotifications();
    // this.listenForNotification();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.sidebar-mini.sidebar-collapse .main-header {
  .main-header {
    .logo {
      width: 50px;

      .logo-mini {
        display: block;
        margin-left: -15px;
        margin-right: -15px;
        font-size: $font_big_20;
      }
      .logo-lg {
        display: none;
      }
    }
  }
}

.sidebar-collapse .sidebar-menu {
  li:hover > ul {
    display: none;
    visibility: hidden;
    opacity: 0;
  }

  li > a:hover {
    background-color: transparent;
    color: #aaa;
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.main-header {
  position: relative;
  max-height: 100px;
  z-index: 1030;

  .logo {
    background-color: $color-mirage;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    width: 50px;
    transition: width 0.3s ease-in-out;
    display: block;
    float: left;
    height: 50px;
    font-size: $font_big_20;
    line-height: 50px;
    text-align: center;
    width: 230px;
    font-family: $mulish-regular;
    padding: 0 15px;
    font-weight: 300;
    overflow: hidden;

    &:hover {
      background-color: $color-eden;
    }
    .logo-mini {
      display: none;

      img {
        width: 30px;
        height: 30px;
        margin-top: 5px;
        margin-left: 5px;
      }
    }
    .logo-lg {
      text-align: left;
      padding-left: 5px;
      img {
        width: 80%;
        height: 30px;
        position: relative;
        top: -2px;
      }
      span {
        color: $color_white;
        font-size: $font_big_20;
        font-weight: 600;
        display: inline-block;
        line-height: 32px;
      }
    }
  }
  .navbar_admin {
    .button_navbar {
      display: block;
      width: 50px;
      height: 50px;
      float: left;
      text-align: center;
      line-height: 50px;
      overflow: hidden;
      color: $color-jungle-green;
      font-size: $font_big_20;

      &:hover {
        color: $color_eden;
      }
    }
    .navbar_admin_custom {
      float: right;
      margin-right: 20px;

      .navbar_nav {
        margin: 10px 0px 10px 0px;

        .item {
          display: inline-block;
          float: left;
          font-size: $font_root;
          color: $color-grey-dusty;
          margin-left: 8px;

          a {
            color: #ccc;
            display: inline-block;
          }
          .notify_head {
            position: relative;
            padding-left: 10px;

            .icon-bell {
              font-size: $font_big_23;
            }
            .number_warning {
              position: absolute;
              display: block;
              min-width: 15px;
              height: 15px;
              padding: 0px 3px;
              border-radius: 8px;
              background-color: $color_corn_pale;
              text-align: center;
              line-height: 15px;
              overflow: hidden;
              top: 0px;
              left: 0px;
            }
          }
          .lang_show {
            display: inline-block;
            float: left;
            line-height: 20px;
            height: 23px;
            border: solid 1px $color_white;
            border-radius: 15px;
            padding: 0px 10px;
            text-transform: uppercase;
            min-width: 47px;

            .icon_dropdow {
              color: $color_silver;
              font-size: 8px;
            }
          }
          .button_out_admin {
            height: 31px;
            line-height: 31px;
            color: $color-jungle-green;
            background-color: $color_white;
            padding: 0px 9px 2px;
            border: 1px solid $color-caribbean-green;
            border-radius: 3px;
            font-weight: 600;
            min-width: 75px;

            i {
              font-style: initial;
              text-transform: uppercase;
            }
            &:hover {
              border-color: $color-aquamarine;
              background-color: $color-aquamarine;
              color: $color_white;
            }
          }
          .dropdown-menu {
            color: $color_grey_text;
            left: auto;
            right: 0px;
            background: transparent;
            border: 0px;
            border-radius: 0px;

            > ul {
              background-color: $color_white;
              box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
              position: relative;
              z-index: 999;
              padding: 10px 0px;
              list-style-type: none;

              &:after {
                bottom: 100%;
                right: 10%;
                border: solid transparent;
                content: " ";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(136, 183, 213, 0);
                border-bottom-color: $color_white;
                border-width: 5px;
                margin-right: 0px;
              }
              li {
                line-height: 20px;
                font-size: $font-small;

                span {
                  padding: 0px 10px;
                  display: block;
                }
                a {
                  display: block;
                  background-color: transparent;
                  color: #ccc;
                  cursor: pointer;
                  padding: 0px 10px;
                  line-height: 20px;

                  &:hover {
                    background-color: $color_white;
                  }
                }
              }
            }
          }

          &.open {
            .lang_show {
              border-color: $color_corn;
              background-color: $color_corn;
              color: $color_white;

              .icon_dropdow {
                color: $color_white;
              }
            }
          }
        }
        .user_navbar {
          margin-left: 10px;
          position: relative;
          .icon-avatar {
            font-size: $font_big_23;
            float: left;
            margin-right: 6px;
          }
          .icon-menu {
            font-size: $font_big_20;
            line-height: 1.4;
            color: $color-jungle-green;
            &:hover {
              cursor: pointer;
            }
          }
          .email_user_navbar {
            line-height: 28px;
            display: inline-block;
            float: left;
            padding-right: 20px;
          }
        }
      }
      .dropdown-head {
        font-family: $mulish-regular;
        width: 160px;
        background: $color-eden;
        margin-top: 2%;
        margin-right: 17px;
        right: 0;
        position: absolute;
        min-height: 85px;
        border-radius: 3px;
        ul {
          margin: 0;
          padding: 0;
          li:first-child {
            border-bottom: 1px solid $color-white-smoke;
          }
          li {
            position: relative;
            overflow: hidden;
            display: block;
            color: $color-white;
            font-size: 14px;
            line-height: 20px;
            padding: 15px 0px;
            text-align: center;

            a {
              font-size: $font_root;
              color: #ccc;
              &:hover {
                color: $color-white;
              }
            }
          }
        }
      }
    }
  }
}

.list_lang {
  .img_lang_navbar {
    height: 14px;
    width: 21px;
    margin-right: 5px;
    position: relative;
    top: -1px;
  }
}
</style>
